class Video {
  player = null;
  observer = null;

  constructor($el) {
    this.$el = $el;
    this.init();
  }

  init = () => {
    // dynamically import plyr

    import('plyr').then((Plyr) => {
      // init plyr
      this.player = new Plyr.default(this.$el[0], {
        controls: ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'fullscreen'],
      });

      this.player.toggleControls(false);
    });
  }
}

export default Video;